// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Grid, Row, Col } from 'react-bootstrap';

import StepHeaderBlock from './StepHeaderBlock';
import { Whitespace, Text } from '../common';
import InputHeader from '../common/FormComponents/InputHeader';
import Input from '../common/FormComponents/InputStyle';
import ListPlaceTips from '../../components/ListPlaceTips/ListPlaceTips';
import FormNav from '../common/FormComponents/FormNav';
import { observer } from 'mobx-react';
import Button from '../common/FormComponents/Button';
import Select from './Select';
import { observable } from 'mobx';

const suggestedRules = [
  'Facebook account must be shared',
  'Must have verified Yoodlize profile',
  'No late returns',
  'Free delivery within 5 mile radius',
  'Must be cleaned before returned'
];

const premadeRules = suggestedRules.map((item, idx) => {
  return <option label={item} value={item} key={idx.toString()} />;
});

@observer
class Rules extends Component {
  @observable nextRuleText = '';
  static propTypes = {
    store: PropTypes.object,
    nextPage: PropTypes.func,
  };

  addRule = () => {
    const { store } = this.props;
    store.addRule(this.nextRuleText);
    this.nextRuleText = '';
  };

  render() {
    const { store, nextPage, admin } = this.props;

    return (
      <Grid>
        <Row>
          <Col xs={12} sm={7} md={7} lg={7}>
            <StepHeaderBlock headerText="Rental rules" />
            <Whitespace smaller />
            <Text noclip large>
              Select one of our pre-made rules or make up your own. You'll have
              access to all requesters profiles to see if they have connected
              their facebook account, phone number, or had their drivers license
              reviewed.
            </Text>
            <Whitespace small />
            <Select
              label="Premade rules"
              onChange={e => {
                store.addRule(e.target.value);
                e.target.value = '';
              }}
            >
              <option />
              {premadeRules}
            </Select>
            <Whitespace />

            <div className="f f-between-center">
              <Input
                style={{ width: '370px' }}
                placeholder="Enter a rule here"
                value={this.nextRuleText}
                onChange={val => {
                  this.nextRuleText = val.target.value;
                }}
                onKeyDown={e => e.keyCode === 13 && this.addRule()}
                primary
              />
              <Button secondary onClick={this.addRule} type="button">
                ADD
              </Button>
            </div>
            <Whitespace small />

            {store.rules.map(rule => (
              <div className="g g-tc-a1a g-g-m f-align-center b-0 bb-1 b-coolGrayLight mb-mxx p-s">
                <i className="fal fa-check-circle t-lx validated" />
                <Text large>{rule.description}</Text>
                <Text
                  clickable
                  onClick={() => store.deleteRule(rule.description, rule.id)}
                >
                  <i className="fal fa-times t-lx" />
                </Text>
              </div>
            ))}
            <Whitespace />
            {!admin && <FormNav nextPage={nextPage} store={store} />}
          </Col>
          {!admin && (
            <Col>
              <ListPlaceTips
                tips={[
                  {
                    title: 'Make yourself comfortable.',
                    tips: [
                      'Create rules for the renter to help you be at peace when handing off your items.',
                      'Photo ID required at pickup.',
                      'Deposit check required for pickup.',
                      'Must be returned clean.',
                    ],
                  },
                  {
                    title: 'List item specific instructions:',
                    tips: ['Hand wash only.', 'Use diesel fuel.'],
                  },
                ]}
              />
            </Col>
          )}
        </Row>
      </Grid>
    );
  }
}

export default Rules;



// WEBPACK FOOTER //
// ./src/components_new/addListing/Rules.js